import { Button, Link, Modal, Text, Tooltip } from '@driftt/dds'
import React from 'react'

const SaveConfirmationModal = ({
  isOpen,
  onClose,
  onAction,
  action = '',
  disabled,
  disabledMessage,
}: {
  isOpen: boolean
  onClose: () => void
  onAction: () => void
  action?: string
  disabled?: boolean
  disabledMessage?: string
}) => (
  <Modal.Root open={isOpen} onClose={onClose}>
    <Modal.Dialog fullWidth size="medium" variant={'warning'}>
      <Modal.Title
        title={'Ready to start training your chatbot on this scenario?'}
      />
      {action === 'save' && (
        <Modal.Content>
          <Text style={{ fontWeight: 'bold' }}>
            {' '}
            You will not be able to edit your description once it's saved.
          </Text>
          <Text>
            {' '}
            Moving forward, you can improve your chatbot's recognition of this
            scenario by providing response ratings on the{' '}
            <Link
              href="/playbooks/testing"
              style={{ color: 'black', textDecoration: 'underline' }}
            >
              AI responses testing
            </Link>{' '}
            and{' '}
            <Link
              href="/reports/conversations/data"
              style={{ color: 'black', textDecoration: 'underline' }}
            >
              Chat data
            </Link>{' '}
            pages.
          </Text>
        </Modal.Content>
      )}
      <Modal.Actions>
        <Button variant="secondary" onClick={onClose}>
          Keep editing
        </Button>
        <Tooltip content={disabled && disabledMessage} side="top">
          <Button variant={'primary'} onClick={onAction} disabled={disabled}>
            Confirm & save changes
          </Button>
        </Tooltip>
      </Modal.Actions>
    </Modal.Dialog>
  </Modal.Root>
)

export default SaveConfirmationModal
